/* THIS FILE IS GENERATED. DO NOT EDIT */

import theme from 'base/components/standalone/SlideShow/theme';

export const SlideShowTheme = theme;
